const isMultiplotOf4 = (number: number): boolean => {
  return number % 4 === 0
}

export default isMultiplotOf4
